import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class JwtDecodeService {
  decodeToken(token: string) {
    if (!token || token === 'null' || token === 'NA' || token === 'undefined') {
      return null;
    }
    
    if (token != null) {
      try {
        // Validate JWT format (should have 3 parts separated by dots)
        const parts = token.split('.');
        if (parts.length !== 3) {
          console.error('Invalid token format: Token must have 3 parts');
          return null;
        }
        
        const payload = parts[1];
        
        // Validate base64 string
        if (!payload || payload.trim() === '') {
          console.error('Invalid token: Empty payload');
          return null;
        }
        
        // Decode and parse
        const decodedPayload = atob(payload);
        return JSON.parse(decodedPayload);
      } catch (error) {
        console.error('Error decoding token:', error);
        return null;
      }
    }
    
    return null;
  }
  isTokenValid(token: string): boolean {
    const decodedToken = this.decodeToken(token);
    if (!decodedToken) {
      return false;
    }

    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    return decodedToken.exp && decodedToken.exp > currentTime;
  }

  // Extract specific values from the token
  getTokenValue(token: string, key: string): any {
    const decodedToken = this.decodeToken(token);
    return decodedToken ? decodedToken[key] : null;
  }
}